import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, InputGroup, Button, Spinner } from "react-bootstrap";
import { Search } from "react-bootstrap-icons";
import CardItem from "../Card/CardItem";
import "./Numbers.css";
import { getAllNumbers } from "../../services/numberService";

function NumbersSale() {
  const [cardsData, setCardsData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [providerFilter, setProviderFilter] = useState("All");
  const [serviceTypeFilter, setServiceTypeFilter] = useState("All");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCards = async () => {
      try {
        const data = await getAllNumbers();
        setCardsData(data);
      } catch (err) {
        setError("Something went wrong!");
      } finally {
        setLoading(false);
      }
    };

    fetchCards();
  }, []); 

  const filteredNumbers = cardsData.filter((item) => {
    const matchSearch = item.number.toLowerCase().includes(searchTerm.toLowerCase());
    const matchProvider = providerFilter === "All" || item.network === providerFilter;
    const matchServiceType = serviceTypeFilter === "All" || item.tag === serviceTypeFilter;
    return matchSearch && matchProvider && matchServiceType;
  });

  return (
    <section className="sell-numbers-section py-5">
      <Container>
        {/* Search + Filter */}
        <Row className="align-items-center mb-4 g-3">
          <Col md={4}>
            <InputGroup>
              <InputGroup.Text className="bg-white">
                <Search className="text-muted" />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Search by number..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </InputGroup>
          </Col>

          <Col md={3}>
            <Form.Select
              value={providerFilter}
              onChange={(e) => setProviderFilter(e.target.value)}
              className="rounded-3"
            >
              <option value="All">All Providers</option>
              <option value="Dialog">Dialog</option>
              <option value="Mobitel">Mobitel</option>
              <option value="Airtel">Airtel</option>
              <option value="Hutch">Hutch</option>
            </Form.Select>
          </Col>

          <Col md={3}>
            <Form.Select
              value={serviceTypeFilter}
              onChange={(e) => setServiceTypeFilter(e.target.value)}
              className="rounded-3"
            >
              <option value="All">All Packages</option>
              <option value="Bronze">Bronze</option>
              <option value="Silver">Silver</option>
              <option value="Gold">Gold</option>
              <option value="Platinum">Platinum</option>
              <option value="Diamond">Diamond</option>
            </Form.Select>
          </Col>

          <Col md={2} className="text-md-end text-center">
            <Button
              variant="outline-dark"
              onClick={() => {
                setSearchTerm("");
                setProviderFilter("All");
                setServiceTypeFilter("All");
              }}
              className="rounded-3"
            >
              Reset
            </Button>
          </Col>
        </Row>

        {/* Loading State */}
        {loading && (
          <div className="text-center py-5">
            <Spinner animation="border" variant="danger" />
          </div>
        )}

        {/* Error State */}
        {error && (
          <div className="text-center text-danger fw-semibold py-5">
            {error}
          </div>
        )}

        {/* Cards Grid */}
        {!loading && !error && (
          <>
            <Row xs={1} md={2} xl={3} className="g-4">
              {filteredNumbers.map((num) => (
                <Col key={num.id} xs={12} sm={6} md={4} lg={3}>
                  <CardItem {...num} />
                </Col>
              ))}
            </Row>
            {filteredNumbers.length === 0 && (
              <div className="text-center py-5 text-muted">
                No numbers found matching your criteria.
              </div>
            )}
          </>
        )}
      </Container>
    </section>
  );
}

export default NumbersSale;
